/** common functions STARTS */

const customProperties = {
    numberOflabels: "Anzahl Etiketten",
    labelType: "Ausführung Etiketten",
    a4Label: "Bogen",
    rollLabel: "Etiketten auf Rollen",
    material: "Material",
    texturedPaper: "Naturpapier",
    standardPaper: "Papier",
    ppFilm: "ppFilm",
    adhesive: "Kleber",
    peelableAdhesive: "Leicht löslich",
    washableAdhesive: "Wasserlöslich",
    permanentAdhesive: "Permanent haftend",
    labelWidth: "Etikettenbreite",
    labelHeight: "Etikettenhöhe",
    windingDirection: "Wickelrichtung",
    windingNoneNeeded: "keine benötigt",
    windingNotPossible: "nicht möglich",
    windingOutside: "Außenwicklung",
    windingInside: "Innenwicklung",
    windingLeftRight: "links/rechts",
    windingLeftAhead: "links voraus",
    windingRightAhead: "rechts voraus"
};

const translations = {
    design_modified_date: "Geändert am",
    page: "Seite",
    of: "von",
    design_load_error_message: "Die Designs konnten nicht geladen werden",
    design_added_to_cart: "Design zum Warenkorb hinzugefügt",
    design_edit_button_name: "Bearbeiten",
    order_again: "Erneut bestellen",
    design_delete_button_name: "Löschen",
    design_search_term: "Bitte geben Sie einen Suchbegriff ein.",
    design_loading_message: "Designs werden geladen...",
    no_design_found_message: "Keine Designs gefunden.",
    no_design_found_error_message: "Beim Laden der Designs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    dimensions_of_label_text: "Abmessungen des Etiketts",
    checkoutValidationTitle: "Ladefehler!",
    checkoutValidationMissing: "Fehlend",
    checkoutValidationFooter: "Bitte lege das Produkt mit den fehlenden Angaben erneut in den Warenkorb und lösche das defekte Produkt.",
    checkoutValidationThankYou: "Danke.",
    checkoutPriceUpdatedTitle: "Preis aktualisiert",
    checkoutPriceUpdatedMessage: "Der Preis einiger Artikel stimmte nicht mit den ausgewählten Optionen überein. Wir haben Ihren Warenkorb mit dem korrekten Preis aktualisiert. Bitte überprüfen Sie Ihren Warenkorb, bevor Sie zur Kasse gehen.",
    ok: "OK",
    design: "Design"
};

document.addEventListener("DOMContentLoaded", function () {

    // const MAP = {
    //     fr: "fr.honeystickers.com",
    //     it: "it.honeystickers.com",
    //     us: "us.honeystickers.com",
    //     de: "de.honeystickers.com"
    // };

    // // Countries that should always stay on DE shop
    // const DE_MARKET_COUNTRIES = new Set(['de','at','ch','li','lu','be']);

    // const EXCLUDE_IPS = new Set([
    //     "103.94.137.241",
    //     "10.203.251.188",
    //     "103.78.17.226"
    // ]);

    // const host = location.hostname;

    // // Run only on DE domain
    // if (host !== MAP.de) return;

    // // Skip bots / crawlers / page testing tools
    // if (/bot|crawl|spider|google|bing|lighthouse|pagespeed|chrome-lighthouse|gtmetrix/i.test(navigator.userAgent)) return;

    // // Prevent multiple redirects in same session
    // if (sessionStorage.getItem("hs_redirected")) return;

    // const browserLang = (navigator.language || "").toLowerCase();

    // fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
    //     .then(r => r.json())
    //     .then(async (data) => {

    //         const country = data?.detected_values?.country?.handle?.toLowerCase();
    //         let target = null;

    //         // Keep DE / AT / CH / LI users on DE shop
    //         if (DE_MARKET_COUNTRIES.has(country)) return;

    //         // Strong country mapping first
    //         if (country === "us") {
    //             target = MAP.us;
    //         } else if (country === "fr") {
    //             target = MAP.fr;
    //         } else if (country === "it") {
    //             target = MAP.it;
    //         }

    //         // Language fallback only
    //         if (!target) {
    //             if (browserLang.startsWith("fr")) {
    //                 target = MAP.fr;
    //             } else if (browserLang.startsWith("it")) {
    //                 target = MAP.it;
    //             } else {
    //                 return; // everyone else stays on DE
    //             }
    //         }

    //         // Safety check
    //         if (!target || target === host) return;

    //         // Excluded office / internal IPs
    //         try {
    //             const txt = await (
    //                 await fetch("https://www.cloudflare.com/cdn-cgi/trace", {
    //                     cache: "no-store"
    //                 })
    //             ).text();

    //             const ip = (txt.match(/^ip=(.+)$/m)?.[1] || "").trim();

    //             if (ip && EXCLUDE_IPS.has(ip)) return;

    //         } catch (e) { }

    //         // Redirect once per session
    //         sessionStorage.setItem("hs_redirected", "1");

    //         const url = new URL(location.href);
    //         url.hostname = target;

    //         location.replace(url.toString());

    //     })
    //     .catch(() => { });

    // Mobile sticky price
    if (window.innerWidth <= 768 && templateGlobal == 'product') {
        scrollProcess();
    }

    // Re-set favicon after Chatlio load
    setTimeout(() => {
        const favicon = document.getElementById("custom-favicon");
        if (favicon) {
            favicon.href = favicon.href;
            document.head.appendChild(favicon);
        }
    }, 2000);

});

function scrollProcess() {
    const priceDiv = document.querySelector(".product-detail__price");
    let lastScrollTop = 0;

    window.addEventListener("scroll", function () {
        let scrollTop = window.scrollY || window.pageYOffset;

        if (scrollTop >= 700 && scrollTop <= 1300) {
            priceDiv.classList.add("fixed");

            if (scrollTop > lastScrollTop) {
                // scrolling down
                priceDiv.classList.add("down");
                priceDiv.classList.remove("up");
            } else {
                // scrolling up
                priceDiv.classList.add("up");
                priceDiv.classList.remove("down");
            }
        } else {
            priceDiv.classList.remove("fixed", "up", "down");
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
}

function toggleDivAndElements(divId, shouldEnable) {
    const div = document.getElementById(divId);
    const elements = div.querySelectorAll('input, select, textarea, button');

    // Show or hide the div
    div.style.display = shouldEnable ? 'block' : 'none';

    // Enable or disable the inner elements
    elements.forEach(el => {
        if (shouldEnable) {
            el.removeAttribute('disabled');
        } else {
            el.setAttribute('disabled', 'disabled');
        }
    });
}

function selectFirstWindingDirection() {
    const group = document.querySelector('#windingDirection .group__options');
    if (!group) return;

    const labels = group.querySelectorAll('.radio-btn');
    const radios = group.querySelectorAll('input[type="radio"]');

    labels.forEach(label => label.classList.remove('selected'));
    radios.forEach(r => r.checked = false);

    // select first option
    labels[0].classList.add('selected');
    radios[0].checked = true;
}


/**decode html encoded string */
function decode(str) {
    let txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

// Function to remove empty keys and values
function removeEmptyKeys(obj) {
    Object.keys(obj).forEach(key => {
        if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        }
    });
}
function formatMoney(cents, format) {

    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
    }

    return formatString.replace(placeholderRegex, value);

}

function customRound(amount) {
    amount = parseFloat(amount.toFixed(2)); // Ensure 2 decimal places

    let wholeNumber = Math.floor(amount); // Extract integer part
    let decimalPart = amount - wholeNumber; // Get decimal part

    let decimalShifted = Math.round(decimalPart * 100); // Convert decimal part to cents
    let remainder = decimalShifted % 10; // Get last digit in cents

    // Adjust rounding logic
    if (remainder === 0) {
        // Already at a .10 multiple
        decimalShifted = decimalShifted;
    } else if (remainder <= 5) {
        // Round down to nearest .10
        decimalShifted -= remainder;
    } else {
        // Round up to nearest .10
        decimalShifted += (10 - remainder);
    }

    // Convert back to decimal form
    return (wholeNumber * 100 + decimalShifted) / 100;
}

function openHoneyLoader() {
    document.getElementById('overlaySpinner').style.display = 'block';
}

function closeHoneyLoader() {
    document.getElementById('overlaySpinner').style.display = 'none';
}

function withLoader(targetElement, callback) {
    let loader = targetElement.querySelector('.button-loader');

    // Create loader if not already present
    if (!loader) {
        loader = document.createElement('span');
        loader.className = 'button-loader';
        targetElement.appendChild(loader);
    }

    loader.classList.remove('hide-btn-loader');

    const result = callback();

    if (result instanceof Promise) {
        result.finally(() => loader.classList.add('hide-btn-loader'));
    } else {
        loader.classList.add('hide-btn-loader');
    }
}

function setPrintlaneImageInLocal(reference, image) {
    const localStorageKey = `colorlab-${reference}`;

    // Prepare data for local storage with expiration
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 60);

    const storageData = {
        expires: expirationDate.toISOString(),
        data: encodeURIComponent(image)
    };

    localStorage.setItem(localStorageKey, JSON.stringify(storageData));
}

function normalizeKey(str) {
    return str
        .normalize('NFD')                       // Decompose accents (e.g., à → a)
        .replace(/[\u0300-\u036f]/g, '')       // Remove diacritics
        .replace(/\s+/g, ' ')                  // Collapse multiple spaces
        .trim()
        .toLowerCase();
}

// Optional: known mappings to fix
const knownKeyCorrections = {
    'quantit etichette': customProperties.numberOflabels,
    'altezza etichetta': customProperties.labelHeight,
    'larghezza etichetta': customProperties.labelWidth,
    'tipologia di etichette': customProperties.labelType,
    'adesivo': customProperties.adhesive,
    'materiale': customProperties.material,
    'sku': 'SKU',
    'customization reference': 'customization reference'
};

function cleanParsedObject(parsedObject) {
    const cleanedObject = {};

    for (const [rawKey, value] of Object.entries(parsedObject)) {
        const normalizedKey = normalizeKey(rawKey);

        // Use known corrected version if available, else fallback to cleaned version
        const finalKey = knownKeyCorrections[normalizedKey] || rawKey.trim();

        cleanedObject[finalKey] = value;
    }

    return cleanedObject;
}




/** common functions ENDS */


/**Main Registration and login STARTS */

//Function to check the customer names start
function validateCustomInputs(ele, errorInfoField) {
    var eleId = ele.id.trim();
    var inputValue = ele.value.trim();

    var inutErrorFlag = false;
    if (eleId == 'LastName' || eleId == 'FirstName') {
        inputValue = inputValue.replace(/[^a-zA-Z \-_.äöüß]/g, '');
        if (inputValue.length == 1) {
            inputValue = inputValue.trim();
        }

        var nameField = 'Vorname';
        if (eleId == 'LastName') {
            nameField = 'Nachname';
        }
        ele.value = inputValue;

        if (inputValue.length < 2) {
            errorInfoField.textContent = 'Das ' + nameField + ' muss mindestens 2 Buchstaben enthalten.';
            errorInfoField.style.display = 'block';
            inutErrorFlag = true;
        }
    }

    if (eleId == 'Email') {
        if (inputValue.length == 0) {
            errorInfoField.textContent = 'E-Mail darf nicht leer sein.';
            errorInfoField.style.display = 'block';
            inutErrorFlag = true;
        } else {
            var emailErrorFlag = validateEmail(inputValue);
            if (!emailErrorFlag) {
                errorInfoField.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
                errorInfoField.style.display = 'block';
                inutErrorFlag = true;
            }
        }
    }

    if (inutErrorFlag) {
        document.querySelector(".regButton").setAttribute("disabled", "disabled");
    } else {
        document.querySelector(".regButton").removeAttribute("disabled");
        errorInfoField.textContent = '';
        errorInfoField.style.display = 'none';
    }
}

//validate email start
function validateEmail(inputText) {
    var mailformat = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return mailformat.test(inputText);
}

// function to validate password
function validatePassword(passwordValue) {
    // Password Validation
    const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return passwordRegex.test(passwordValue);
}

//Function to display VAT input on registration
var countrySelectionCommon = '';
const hideError = () => {
    document.getElementById('formErrors').textContent = "";
    document.getElementById('jsFormAlert').style.display = "none";
    countrySelectionCommon = '';
};
function processVatChoice(vatValue) {
    var selectedVatvalue = vatValue.value;
    if (selectedVatvalue == 'Firma') {
        document.getElementById('vatCountrySelectMain').style.display = 'block';
        document.getElementById('vatCountrySelectMain').removeAttribute('disabled');
        if (countrySelectionCommon == 'InsideEU') {
            document.getElementById('customerVatAdd').style.display = 'block';
            document.getElementById('customerVat').removeAttribute('disabled');
        }
    } else {
        document.getElementById('vatCountrySelectMain').style.display = 'none';
        document.getElementById('vatCountrySelectMain').setAttribute('disabled', 'disabled');
        document.getElementById('customerVatAdd').style.display = 'none';
        document.getElementById('customerVat').value = "";
        document.getElementById('customerVat').setAttribute('disabled', 'disabled');
        hideError();
    }
}

function toggleVatFieldsByCountry(option) {
    countrySelectionCommon = option.trim();
    if (option.trim() == 'InsideEU') {
        document.getElementById('customerVatAdd').style.display = 'block';
        document.getElementById('customerVat').removeAttribute('disabled');
    } else {
        document.getElementById('customerVatAdd').style.display = 'none';
        document.getElementById('customerVat').setAttribute('disabled', 'disabled');
        hideError();
    }
}

const showError = (message) => {
    document.getElementById('formErrors').textContent = message;
    //document.querySelector(".regButton").setAttribute("disabled", "disabled");
    document.getElementById('jsFormAlert').style.display = "block";
};

//Function to submit registration form
function submitRegisterForm() {
    hideError();
    const form = document.getElementById("create_customer");
    const formData = new FormData(form);

    let accptMarketing = false;
    let vatChosen = "Privatperson";
    let vatNumber = '', email = '', firstName = '', lastName = '', password = '';

    for (let [key, value] of formData.entries()) {
        switch (key) {
            case 'customer[accepts_marketing]': accptMarketing = true; break;
            case 'vat_choose_add': vatChosen = value; break;
            case 'customer[note][Umsatzsteuer-ID]': vatNumber = value; break;
            case 'customer[email]': email = value; break;
            case 'customer[first_name]': firstName = value; break;
            case 'customer[last_name]': lastName = value; break;
            case 'customer[password]': password = value; break;
        }
    }

    firstName = firstName.replace(/[^a-zA-Z \-_.äöüß]/g, '').trim();
    lastName = lastName.replace(/[^a-zA-Z \-_.äöüß]/g, '').trim();


    if (firstName.length < 2) return showError('Der Vorname muss mindestens zwei Buchstaben enthalten.');
    if (lastName.length < 2) return showError('Der Nachname muss mindestens zwei Buchstaben enthalten.');
    if (!email) return showError('Das E-Mail-Feld ist erforderlich.');
    if (!validateEmail(email)) return showError('Bitte gib eine gültige E-Mail-Adresse ein.');
    if (!validatePassword(password)) return showError('Das Passwort muss mindestens 8 Zeichen lang sein und Buchstaben, Zahlen sowie Sonderzeichen enthalten.');

    document.getElementById('jsFormAlert').style.display = "none";

    if (!accptMarketing) {
        document.getElementById('customerAcceptMarketing').value = "false";
    }

    // Tag construction
    let tags = vatChosen === "Firma"
        ? (vatNumber ? `Umsatzsteuer-ID:${vatNumber}, ` : '') + "customerType:B2B"
        : "customerType:B2C";

    document.getElementById('customerTags').value = tags;

    if (countrySelectionCommon === 'InsideEU' && !vatNumber) {
        showError("Bitte geben Sie eine gültige USt-IdNr. ein.");
        return;
    }


    if (vatNumber) {

        const btn = document.querySelector(".regButton");
        btn.classList.add('spin');

        //validate VAT and update for address in customer
        var postData = {
            "vatId": vatNumber,
            "customerEmail": email,
            "shop": storeGlobal
        };

        fetch(backendURL + '/shopify/customer/validate-vat', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(postData)
        })
            .then(response => response.json())
            .then(data => {
                $(".regButton").removeClass('spin').removeAttr("disabled");
                console.log(data, '------------response');

                if (data.status == 200) {
                    showError("USt-IdNr. erfolgreich aktualisiert.");
                    if (email.length > 0) {
                        form.submit();
                    }

                } else {

                    if (data.message == "invalidCustomer") {
                        showError("Ungültige Kundendaten oder -details.");
                    }
                    if (data.message == "invalidVat") {
                        showError("Bitte gib eine gültige USt-IdNr. ein.");
                    }

                }

            })
            .catch(error => {
                console.error(error, 'Failed to validate vat');
            })
            .finally(() => {

            });

        /*$.ajax({
            url: backendURL + '/shopify/validateVatId',
            type: "POST",
            crossDomain: true,
            dataType: 'jsonp',
            data: { "data": JSON.stringify(postData) }
        }).done(function (response) {

            $(".regButton").removeClass('spin').removeAttr("disabled");
            console.log(response,'------------response');
            if (response.status == 200) {
                showError("USt-IdNr. erfolgreich aktualisiert.");
                if (email.length > 0) {
                    form.submit();
                }

            } else {

                if (response.message == "invalidCustomer") {
                    showError("Ungültige Kundendaten oder -details.");
                }
                if (response.message == "invalidVat") {
                    showError("Bitte gib eine gültige USt-IdNr. ein.");
                }

            }

        }).fail(function (response) {
            // console.error(response);
            // $('.cartLoader').addClass('hide');
        });*/
    } else {
        form.submit();
    }
}


function displayRegisterVatMessage(message, color) {
    var vatRegisterErrorInfo = document.querySelector('.vatRegistererrorInfo');
    vatRegisterErrorInfo.textContent = message;
    vatRegisterErrorInfo.style.color = color;
    vatRegisterErrorInfo.style.padding = '5px 10px';
    vatRegisterErrorInfo.style.backgroundColor = '#fff';
}

function addProdToCart(id, qty, props) {

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: qty,
            id: id,
            properties: props
        },
        dataType: 'json',
        success: function (response) {

            cartCacheCheck = setInterval(function () {

                $.ajax({
                    url: '/cart.js?cache=false',
                    type: 'post',
                    dataType: 'json',
                    success: function (res) {
                        if (res.items != undefined) {
                            $.each(res.items, function (key, lineItem) {

                                if (lineItem.id == id && lineItem.price > 0) {
                                    clearInterval(cartCacheCheck);
                                    window.location.href = '/cart';
                                }
                            })
                        }
                    }
                });

            }, 500);

        },
        error: function (err) {
            console.log(
                'Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.'
            );
        }
    });
}

/**Main Registration and login ENDS*/


function showModal({
    title = '',
    content = '',
    buttons = []
}) {

    const modal = document.getElementById('common-modal');

    modal.querySelector('.common-modal__title').innerHTML = title;
    modal.querySelector('.common-modal__content').innerHTML = content;

    const buttonContainer = modal.querySelector('.common-modal__buttons');
    buttonContainer.innerHTML = '';

    buttons.forEach(button => {

        const btn = document.createElement('button');

        btn.textContent = button.text;
        btn.className = button.class || 'button button--regular  button--regular-mobile  button--solid';

        btn.onclick = () => {

            if (button.onClick) {
                button.onClick();
            }

            hideModal();
        };

        buttonContainer.appendChild(btn);
    });

    modal.classList.remove('hidden');
}

function hideModal() {
    document.getElementById('common-modal').classList.add('hidden');
}

document.querySelector('.common-modal__close').onclick = hideModal;
document.querySelector('.common-modal__overlay').onclick = hideModal;
